import Vue from "vue";


export async function index(params = {}) {
  const response = await Vue.prototype.$http.get("/room_types", {
    params
  });

  return response.data;
}
